import classnames from 'classnames';
import { If } from 'components';
import { selectHoverState, selectMenuState } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { NavTab, navTabKeys } from 'types/baseTypes';
import { getNavSvgHighightStyle } from 'utils/styleUtils';
import { isTablet } from 'react-device-detect';
import { DownArrowIcon } from 'assets/icons';

interface NavTabProps {
  tab: NavTab;
  activeTab: NavTab;
  isActiveSubTab?: boolean;
  onNavTabClick: (tab: NavTab) => void;
  isBottomBar?: boolean;
  subTabClassname?: string;
  hasActiveChildTab?: boolean;
}

const SideNavTab: FC<NavTabProps> = ({
  tab,
  activeTab,
  onNavTabClick,
  isBottomBar,
  isActiveSubTab,
  subTabClassname,
  hasActiveChildTab
}) => {
  const isMenuActive = useAppSelector(selectMenuState);
  const isHoverActive = useAppSelector(selectHoverState);
  const isActiveTab = (navTab: NavTab) => activeTab.key === navTab.key;

  return (
    <div
      onClick={() => onNavTabClick(tab)}
      key={tab.key}
      className={twMerge(
        'hover:cursor-pointer flex flex-row gap-4 py-3 px-4 rounded-md',
        classnames({
          'min-w-[175px]': isMenuActive || (isHoverActive && !isTablet),
          'rounded-md bg-secondaryBtn': isActiveTab(tab) || hasActiveChildTab,
          'justify-center': !isBottomBar,
          'items-center justify-start': (isMenuActive || (isHoverActive && !isTablet)) && !isBottomBar,
          [subTabClassname]: subTabClassname && (isMenuActive || isHoverActive)
        })
      )}>
      <div
        className={twMerge(
          classnames({
            'pl-0': !isMenuActive,
            'w-full': (isMenuActive || (isHoverActive && !isTablet)) && !isBottomBar,
            'rounded-md px-4 py-2': !isMenuActive && !isHoverActive && isActiveSubTab
          }),
          'flex flex-row gap-4 items-center'
        )}>
        <tab.icon
          className={classnames('shrink-0', {
            [`${getNavSvgHighightStyle(tab)} text-secondaryBtnText`]: isActiveTab(tab) || isActiveSubTab,
            'mt-1 self-start': tab.key === navTabKeys.discounts
          })}
          id={isBottomBar ? 'bottom-bar' : 'side-nav'}
          width={20}
        />
        <If condition={isMenuActive || isBottomBar || (isHoverActive && !isTablet)}>
          <div
            id={tab.id}
            className={twMerge(
              classnames(
                `max-w-[170px] text-[15px] font-semibold leading-4 
                text-primaryText duration-300 ease-in-out`,
                {
                  'text-secondaryBtnText': isActiveTab(tab) || isActiveSubTab,
                  'min-w-[130px]': !tab.hasChildTabs,
                  'min-w-[90px]': tab.hasChildTabs
                }
              )
            )}>
            {tab.title}
          </div>
          {tab.hasChildTabs && (
            <DownArrowIcon className={`${activeTab.key === tab.key ? 'rotate-180' : ''} ml-auto shrink-0`} />
          )}
        </If>
      </div>
    </div>
  );
};

export default SideNavTab;
